import {
  pick,
  endsWith,
  isEmpty,
  forEach,
  partial,
  is,
  assocPath,
  forEachObjIndexed,
  reject,
  isNil,
  map,
  pipe,
  head,
  last,
  reduce,
  split,
  contains,
  pluck
} from 'ramda';

import {filterAvailParams, filterAvailLoyaltyParams, filterAvailCalendarParams} from '@synergycms_core/store/customer/paramsUtils';

import { fromJS } from 'immutable';

import moment from 'moment';

export default class ParamsParser {
  static getGuest(search) {
    const defaultGuests = null;

    const uri = decodeURI(search || window.location.search);

    // RegExps
    const regExpSBrackets = /\[(\w*?)]/g;
    const getURIRegExp = prop => {
      return new RegExp(prop + '([^=]+)=([^&]+)', 'g');
    };

    const getMatches = (regex, str, isKeyValue) => {
      let result = isKeyValue ? {} : [];
      let iterator;
      let i = 0;
      let count = 0;
      while ((iterator = regex.exec(str)) !== null) {
        if (isKeyValue) {
          var keys = getMatchesSBrackets(iterator[1]);
          if (keys[0] === '') {
            keys[0] = i;
          }
          result = assocPath(keys, iterator[2], result);
          count++;
          if (count > 0 && count % 2 === 0) {
            i++;
          }
        } else {
          result.push(iterator[1]);
        }
      }

      return result;
    };

    // Partials
    const getMatchesKeyValue = prop => {
      return getMatches(getURIRegExp(prop), uri, true);
    };

    const getMatchesSBrackets = partial(getMatches, [regExpSBrackets]);
    // Primer mirem si ens arriba el paràmetre 'guests'
    // guests[0][adults]=1 i guests[0][childs]=1
    let guests = getMatchesKeyValue('guests');
    let i;

    if (!isEmpty(guests)) {
      let result = {};
      forEachObjIndexed((v, k) => {
        forEachObjIndexed((guestNum, guestType) => {
          if (parseInt(guestNum, 10)) {
            result = assocPath([k, guestType], parseInt(guestNum, 10), result);
          }
        }, v);
        result = assocPath([k, "childsAge"], [], result);
      }, guests);
      guests = result;
    } else {
      // En cas de no trobar el paràmetre 'guests' busquem el 'pax'
      // pax[1]=2,0
      guests = getMatchesKeyValue('pax');
      let finalOccup = {};
      if (!isEmpty(guests)) {
        i = 0;
        forEachObjIndexed((v, k) => {
          let result = {};
          var values = v.toString().split(',');

          // Aquest if es pes si ens passen el 'pax' sense posició a l'array
          // pax[]=2,0
          if (k) {
            finalOccup[parseInt(k, 10)] = result;
          } else {
            finalOccup[parseInt(i, 10)] = result;
          }
          const subKeys = ['adults', 'childs'];
          for (let idx = 0; idx < subKeys.length; idx++) {
            if (parseInt(values[idx], 10)) {
              result[subKeys[idx]] = parseInt(values[idx], 10);
            }
          }
          i++;
        }, guests);
        guests = finalOccup;
      }
    }

    // Separar los parámetros

    var regex = new RegExp(/childs\[(\d+)\]=(\d+)/, 'g');
    let childInfo, childsAge, segment, age;
    while ((childInfo = regex.exec(uri)) !== null) {
      segment = childInfo[1];
      age = childInfo[2];
      childsAge = guests[segment].childsAge || [];
      if(guests[segment].childs > childsAge.length) {
        guests[segment].childsAge = [...childsAge, {age:parseInt(age,10), idx:childsAge.length+1}];
      }
    }


    // Retornem la coincidencia o el valor per defecte
    return isEmpty(guests) ? defaultGuests : guests;
  }

  static mapParams(key) {
    const map = {
      id_hotel: 'hotelCode',
      hotel_id: 'hotelCode',
      'hotels[]': 'hotelCodes',
    };
    return map[key] ? map[key] : key;
  }


  static invalidParams = value => {
    return isNil(value) || value === '' || (is(Array, value) && !value.length);
  };




  //recupera els parametres utilitzats a la url per el cms
  static paramsToUrl(params, requiredParams = []) {
    params = params.toJS();
    return pipe(
      pick(map(ParamsParser.mapParams, requiredParams)),
      reject(ParamsParser.invalidParams),
      fromJS
    )({
      hotelCodes: !params.hotelCode && params.hotelCodes,
      hotelCode: params.hotelCode,
      start: params.date,
      end: moment(params.date)
        .add(+params.stay_length, 'days')
        .format('YYYY-MM-DD'),
      avail_code: params.avail_code,
      id_referer: params.avail_code,
      gift_voucher: params.gift_voucher,
      promotion_code: params.promotion_code,
      company_id: params.company_id,
      referer_code: params.referer_code,
      occups: params.occups,
      country_id: params.country_id,
      city_id: params.city_id,
      tdckehc: params.tdckehc,
      testing_mode: params.testing_mode,
      extended_testing_mode: params.extended_testing_mode,
      from_tms: params.from_tms,
      tms_tracking: params.tms_tracking,
      prepayment_id: params.prepayment_id,
      prepayment_amount: params.prepayment_amount,
      POS: params.POS,
      currency: params.currency,
      pin: params.pin,
      utm_source: params.utm_source,
      utm_medium: params.utm_medium,
      utm_campaign: params.utm_campaign,
      utm_term: params.utm_term,
      tracking_id: params.tracking_id,
      tpv_result: params.tpv_result,
      refid: params.refid,
      td: params.td,
      msclkid: params.msclkid,
      trv_reference: params.trv_reference,
      clickID: params.clickID,
      gclid: params.gclid,
      yclid: params.yclid,
      selection_avail: params.selection_avail,
      tt_meta: params.tt_meta,
      tt_gha_campaign_id: params.tt_gha_campaign_id,
      tt_ad_type: params.tt_ad_type,
      tt_adults: params.tt_adults,
      tt_checkin: params.tt_checkin,
      tt_checkout: params.tt_checkout,
      tt_children: params.tt_children,
      tt_date_type: params.tt_date_type,
      tt_los: params.tt_los,
      tt_partner_id: params.tt_partner_id,
      tt_user_country: params.tt_user_country,
      tt_user_device: params.tt_user_device,
      qt_tracking_id: params.qt_tracking_id,
      _askSI: params._askSI
    });
  }

  //recupera els parametres utils de la url del cms
  static urlToParams(stringParams) {
    const regex = /[?&]([^=#]+)=([^&#]*)/g;
    const url = stringParams;
    let params = {},
      match,
      key,
      value;
    const parseSelectionAvailParams = pipe(
      split(','),
      reduce((result, param) => {
        const filedVale = split(':', param);
        result[head(filedVale)] = last(filedVale);
        return result;
      }, {})
    );
    //var teest = new URLSearchParams(url);
    while ((match = regex.exec(url))) {
      value = match[2];
      key = ParamsParser.mapParams(match[1]);
      if (endsWith('[]', match[1])) {
        if (params[key]) {
          params[key].push(value);
        } else {
          params[key] = [value];
        }
      } else if ('pcry' === key) {
        forEach(keyVal => {
          // eslint-disable-next-line
          const [all, subKey, subValue] = keyVal.match(/\[([^\]]+)\]=(.*)/);
          params[ParamsParser.mapParams(subKey)] = subValue;
        }, atob(decodeURIComponent(value)).split('&'));
      } else if ('resRequest' === key) {
        params[key] = JSON.parse(atob(value));
      } else if ('entrada' === key) {
        params['start'] = moment(value, 'DDMMYYYY').format('YYYY-MM-DD');
      }
      // format key única
      else if (contains(key, ['selection_avail'])) {
        params['selection_avail'] = [parseSelectionAvailParams(value)];
      }
      // format array
      else if (key.indexOf('selection_avail') !== -1) {
        key = 'selection_avail';
        if (params[key]) {
          params[key].push(Object.assign({}, parseSelectionAvailParams(value)));
        } else {
          params[key] = [Object.assign({}, parseSelectionAvailParams(value))];
        }
      } else {
        params[key] = value;
      }
    }
    if (params.noches) {
      params.end = moment(params.start, 'YYYY-MM-DD')
        .add(params.noches, 'days')
        .format('YYYY-MM-DD');
    }

    const formatDateRegExp = new RegExp('^\\d{2}\\-\\d{2}\\-\\d{4}$', 'g');
    if (formatDateRegExp.test(params.start)) {
      params.start = moment(params.start, 'DD-MM-YYYY').format('YYYY-MM-DD');
      params.end = moment(params.end, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }

    //http://localhost:3000/?action=buscador&id_hotel=E150&entrada=22072019&noches=3&rooms=1&pax%5b1%5d=2,1&pax%5b2%5d=2,3&idioma=ES&id_referer=TRIPADVISOR_MB_ES&td=a00ta00&utm_source=tripadvisor&utm_medium=cpc&utm_campaign=tripadvisor_es&utm_term=E150&refid=XLhNwAoQECIAAlweKckAAAIR&tdckehc=1
    return fromJS(
      reject(ParamsParser.invalidParams, {
        hotelCodes: params.hotelCodes,
        hotelCode: params.hotelCode,
        start: params.start,
        end: params.end,
        promotion_code: params.promotion_code,
        referer_code: params.referer_code,
        company_id: params.company_id,
        avail_code: params.avail_code || params.id_referer,
        id_referer: params.avail_code || params.id_referer,
        gift_voucher: params.gift_voucher,
        occups: ParamsParser.getGuest(stringParams),
        resRequest: params.resRequest,
        country_id: params.country_id,
        city_id: params.city_id,
        tdckehc: params.tdckehc,
        testing_mode: params.testing_mode,
        extended_testing_mode: params.extended_testing_mode,
        from_tms: params.from_tms,
        tms_tracking: params.tms_tracking,
        prepayment_id: params.prepayment_id,
        prepayment_amount: params.prepayment_amount,
        POS: params.POS,
        currency: params.currency,
        pin: params.pin,
        utm_source: params.utm_source,
        utm_medium: params.utm_medium,
        utm_campaign: params.utm_campaign,
        utm_term: params.utm_term,
        tracking_id: params.tracking_id,
        tpv_result: params.tpv_result,
        refid: params.refid,
        td: params.td,
        msclkid: params.msclkid,
        trv_reference: params.trv_reference,
        clickID: params.clickID,
        gclid: params.gclid,
        yclid: params.yclid,
        selection_avail: params.selection_avail,
        tt_meta: params.tt_meta,
        tt_gha_campaign_id: params.tt_gha_campaign_id,
        tt_ad_type: params.tt_ad_type,
        tt_adults: params.tt_adults,
        tt_checkin: params.tt_checkin,
        tt_checkout: params.tt_checkout,
        tt_children: params.tt_children,
        tt_date_type: params.tt_date_type,
        tt_los: params.tt_los,
        tt_partner_id: params.tt_partner_id,
        tt_user_country: params.tt_user_country,
        tt_user_device: params.tt_user_device,
        room_id: params.room_id,
        qt_tracking_id: params.qt_tracking_id,
        _askSI: params._askSI,
      })
    );
  }

  //converteix els parametres a string per la url del cms
  static convertParamsToStringQuery(params) {
    params = params.toJS ? params.toJS() : params;
    let result = [];
    const filteredParams = reject(ParamsParser.invalidParams, params);
    forEachObjIndexed((param, key) => {
      if (key === 'hotelCodes') {
        if (is(Array, param)) {
          result.push(
            param
              .map(hotel => {
                return 'hotels[]=' + hotel;
              })
              .join('&')
          );
        }
      } else if (key === 'hotelCode') {
        result.push('id_hotel=' + param);
      } else if (key === 'occups') {
        let segmentsQuery = [];
        let childsInfoQuery = [];
        let occupQuery, childsAgeQuery;
        forEachObjIndexed((occups, keySegment) => {
          occupQuery = [];
          childsAgeQuery=[];

          forEachObjIndexed((occup, occupKey) => {
            if (occupKey === 'adults') {
              occupQuery.push('guests[' + keySegment + '][adults]=' + occup);
            } else if (occupKey === 'childs') {
              occupQuery.push('guests[' + keySegment + '][childs]=' + occup);
            }
          }, occups);

          if (occups.childsAge && occups.childsAge.length) {
            forEachObjIndexed((child, age) => {
              childsAgeQuery.push(`childs[${keySegment}]=${child.age}`);
            }, occups.childsAge);
          }

          segmentsQuery.push(occupQuery.join('&'));
          childsAgeQuery.length && childsInfoQuery.push(childsAgeQuery.join('&'));
        }, param);

        result.push(segmentsQuery.join('&'));
        childsInfoQuery.length && result.push(childsInfoQuery.join('&'));
      } else if (key === 'selection_avail') {
        let selectionsQuery = [];
        let selectionQuery;
        forEachObjIndexed((selections, keySegment) => {
          selectionQuery = [];
          forEachObjIndexed((paramValue, paramKey) => {
            selectionQuery.push(paramKey + ':' + paramValue);
          }, selections);
          selectionsQuery.push(key + '[' + keySegment + ']=' + selectionQuery.join(','));
        }, param);
        result.push(selectionsQuery.join('&'));
      } else {
        result.push(key + '=' + param);
      }
    }, filteredParams);
    return reject(ParamsParser.invalidParams, result).join('&');
  }

  //converteix els params obj a stringQuery per syn2
  static paramsToQuery(params) {
    params = params.toJS();
    let query = [];
    forEachObjIndexed((value, key) => {
      if (value) {
        if (key === 'occups') {
          let segmentsQuery = [];
          let childInfoQuery = [];
          let occupQuery,childsAgeQuery;
          forEachObjIndexed(occups => {
            occupQuery = [];
            childsAgeQuery = [];
            forEachObjIndexed((occup, occupKey) => {
              if (occupKey === 'adults') {
                occupQuery.push('3-' + occup);
              } else if (occupKey === 'childs') {
                occupQuery.push('2-' + occup);
              } else if(occupKey === 'childsAge'){
                childsAgeQuery.push(pluck('age', occup))
              }
            }, occups);

            segmentsQuery.push(occupQuery.join(','));
            childsAgeQuery.length && childInfoQuery.push(childsAgeQuery.join(','));
          }, value);
          query.push(key + ':(' + segmentsQuery.join(';') + ')');
          childInfoQuery.length && query.push('childs_info' + ':(' + childInfoQuery.join(';') + ')');

        } else if (key !== 'hotels' && key !== 'hotelId') {
          if (is(Array, value)) {
            query.push(key + ':' + value.join(';'));
          } else {
            query.push(key + ':' + value);
          }
        }
      }
    }, params);
    return query.join(',');
  }
}


export class ParamsContext {

  constructor(params, contextualizer, storeCallback) {

    this.codeContextualizer = contextualizer;
    this.prefix = contextualizer === "standar" ? "" : contextualizer;
    this.contextualizer = this.context[contextualizer];
    this.storeCallback = storeCallback;
    this.baseParams = this.contextualizer(params.set());
    this.stringBaseParams = ParamsParser.paramsToQuery(this.baseParams);
    this.params = params.set();
  }

  context = {
    "standar" : filterAvailParams,
    "loyalty" : filterAvailLoyaltyParams,
    "calendar" : filterAvailCalendarParams
  };

  params;
  stringParams;
  clone = () => {
    const clone = new ParamsContext(this.baseParams, this.codeContextualizer, this.storeCallback);
    clone.toObj(this.params);
    return clone;
  }

  toObjType = (contextualizer, newParams, fromBase)=> {
    return this.context[contextualizer]((fromBase ? this.baseParams : this.params).merge(newParams));
  }

  toStringType = (contextualizer, params)=> {
    //const newParams = this.toObjType(contextualizer, params, fromBase);
    return ParamsParser.paramsToQuery(this.context[contextualizer](params));
  }

  toObj = (newParams, preventSave = false) => {
    const params = this.params.merge(newParams && this.contextualizer(newParams));

    if(!preventSave) {
      this.params = params
    }
    return params;
  }

  store = (hotId)=> {
    this.storeCallback && this.storeCallback(hotId, this);
  };

  getPrefix = () => {
    const prefix = this.prefix ? this.prefix+"_" : "";

    return {
      base :`base_string_${prefix}query_params`,
      params :`${prefix}query_params`,
      stringParams :`string_${prefix}query_params`,
      paramsService :`service_${prefix}query_params`,
      stringService :`string_service_${prefix}query_params`,
      paramsCalendar :`calendar_${prefix}query_params`,
      stringCalendar :`string_calendar_${prefix}query_params`,
      baseParamsCalendar :`base_calendar_${prefix}query_params`,
      baseStringCalendar :`base_string_calendar_${prefix}query_params`,
    }
  };




  toString = (params, preventSave = false) => {
    const newParams = this.toObj(params, preventSave);
    return ParamsParser.paramsToQuery(this.contextualizer(newParams));
  }
}
